/**
 * Return download url from OS data
 * @param {OS} client 
 */
export default function getDownloadLink(client) {
    return `/content/download/${client.branch}/${client.os}/${client.bits}`;
}
